// extracted by mini-css-extract-plugin
export default {"card":"BookmarkCard_card__VWP3R","tab":"BookmarkCard_tab__pyS+V","left":"BookmarkCard_left__cQ15C","right":"BookmarkCard_right__qeK3G","learnMore":"BookmarkCard_learnMore__bXQzd"};